"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { Sidebar } from "@/components/layout/sidebar";
import { SidebarProvider } from "@/components/layout/sidebar-context";
import { useAuthStore } from "@/store/auth.store";

export default function DashboardLayout({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isReady } = useAuthStore();
  const router = useRouter();

  useEffect(() => {
    if (isReady && !isAuthenticated) {
      router.replace("/login");
    }
  }, [isAuthenticated, isReady, router]);

  if (!isReady || !isAuthenticated) return null;

  return (
    <SidebarProvider>
      <div className="admin-shell flex h-full w-full">
        <Sidebar />
        <div className="admin-content flex-1 flex flex-col min-h-0 overflow-hidden">
          {children}
        </div>
      </div>
    </SidebarProvider>
  );
}
